import { useEffect } from 'react';
import Banner from '../../components/common/Banner';
import SiteLayout from '../../components/common/SiteLayout';
import usePageMeta from '../../components/common/usePageMeta';

const cardClasses = {
    navy: 'border-[rgba(0,227,135,0.4)] bg-[rgb(17,16,56)] text-white',
    white: 'border-[#DDE2E5] bg-white text-[#111038]',
};

export default function ThankYouPage({ page }) {
    const [before, highlight, after] = page.title.split(/\[(.+)\]/);
    const green = page.banner ? 'text-[#00E387]' : 'text-[#22c55e]';
    const title = <>{before}<span className={green}>{highlight}</span>{after}</>;

    usePageMeta(page);

    useEffect(() => {
        if (page.pixelEvent) window.fbq?.('track', ...page.pixelEvent);
    }, [page]);

    return (
        <SiteLayout headerVariant="full" overlayHeader={page.banner} mainClassName={page.banner ? '' : 'bg-white'}>
            {page.banner && (
                <Banner>
                    <h1 className="font-['Mango_Grotesque'] text-[90px] font-extrabold uppercase leading-[0.8] min-[861px]:text-[110px] min-[1141px]:text-[170px]">
                        {title}
                    </h1>
                </Banner>
            )}

            <div className={`px-[15px] pb-[91px] ${page.banner ? '' : 'pt-8 md:pt-6'}`}>
                {!page.banner && (
                    <h1 className="mb-8 text-center font-['Mango_Grotesque'] text-[48px] font-bold uppercase leading-[0.85] text-[#121212] md:mb-6 md:text-[64px] min-[1025px]:leading-[1.125]">
                        {title}
                    </h1>
                )}

                <div
                    className={`mx-auto w-full max-w-[816px] rounded-[20px] border p-[40px_35px] text-center text-[18px] font-medium leading-[1.7] [&_p+p]:mt-5 ${cardClasses[page.card]}`}
                >
                    {page.body}
                </div>
            </div>
        </SiteLayout>
    );
}
